import React from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import DataImportTableWidget from '../../../widgets/auditWidgets/auditReportSummaryWidgets/DataImportTableWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function AuditFileImport() {
  const params = new URLSearchParams(window.location.search)
  const type = params.get('type')

  // console.log('param => ', type)

  if (!type) {
    return (
      <SidebarProposal isAudit>
        <ErrorWidget statusCode={500} errorMessage={'Type is Emty.'} />
      </SidebarProposal>
    )
  }

  if (type != 'imp01' && type != 'imp02' && type != 'imp03') {
    return (
      <SidebarProposal isAudit>
        <ErrorWidget statusCode={500} errorMessage={'Type not equal.'} />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAudit>
        <ContentHeader
          header={
            type == 'imp01'
              ? 'นำเข้าข้อมูลโครงการสำหรับตรวจสอบข้อมูล'
              : type == 'imp02'
              ? 'นำเข้าข้อมูลโครงการสุ่มตรวจ'
              : 'นำเข้าข้อมูลเกรด'
          }
          subHeader={''}
          isNotCallApi
          isShowGoButton
        />

        <DataImportTableWidget type={type} />
        <br />
      </SidebarProposal>
    </div>
  )
}
